import SideMenu, { SideMenuProps } from '@elem/compCommon/SideMenu';
import { createPortal } from 'react-dom';
import EmailSubscribe, { PAGE_TYPE } from '@elem/compCommon/EmailSubscribe';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import J from './components/J';
import K from './components/K';
import L from './components/L'; // 暂未获得授权，临时取消上线
import M from './components/M';
import N from './components/N';
import JoinUs from './components/JoinUs';
import ProductInlineBanner from '@/components/PIBanner';
import { useGlobal } from '@/utils/useGlobal';

export default function IndexDynamic() {
    const { useState, useLang, useEffect, useRouter } = useGlobal();
    const { locale } = useRouter();
    const [isClient, setIsClient] = useState(false);
    const { t } = useLang('powerbackup');

    const obj: SideMenuProps = {
        items: [
            { text: t('secD_btn1'), link: '#power-backup-E' },
            { text: t('secD_btn2'), link: '#power-backup-F' },
            { text: t('secD_btn3'), link: '#power-backup-G' },
            { text: t('secD_btn4'), link: '#power-backup-H' },
        ],
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            <B />
            <C />
            <D tags={obj.items} />
            <E />
            {['us', 'ca'].includes(locale) && <ProductInlineBanner />}
            <F />
            <G />
            <H />
            <EmailSubscribe
                locale={locale}
                className="email-subscribe"
                pageType={PAGE_TYPE.HomeBackup}
                entry_position={['us', 'ca']?.includes(locale) ? 9 : 8}
            />
            <J />
            {['au'].includes(locale) && <JoinUs />}
            {!['kr'].includes(locale) && <K />}
            <L />
            {!['kr'].includes(locale) && <M />}
            <N />
            <h2 className="annotation">{t('secO')}</h2>
            {isClient && createPortal(<SideMenu items={obj.items} />, document.querySelector('#Widgets-box-in2-right-id') || document.body)}
        </>
    );
}
